export default {
    callable: (element: HTMLElement) => {
        createObserver();

        let observer: IntersectionObserver;
        function createObserver() {
            let options = {
                root: null,
                rootMargin: '0px',
                threshold: [0.5],
            };

            observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(element);
        }

        let handle: number;

        function handleIntersect(entries: IntersectionObserverEntry[]) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio >= 0.5) {
                    handle = window.setTimeout(handleInscreen, 1000);
                } else {
                    if (handle) {
                        clearTimeout(handle);
                    }
                }
            });
        }

        function handleInscreen() {
            if (observer) {
                observer.unobserve(element);
                observer.disconnect();
            }

            const lazyImgEles = element.querySelectorAll(
                'img[data-viewed-src]'
            );
            [].forEach.call(lazyImgEles, (ele: HTMLImageElement) => {
                ele.addEventListener('load', () => {
                    if (ele.parentNode) {
                        ele.parentNode.removeChild(ele);
                    }
                });
                ele.src = ele.getAttribute('data-viewed-src') || '';
                ele.removeAttribute('data-viewed-src');
            });
        }
    },
};
